import { render, staticRenderFns } from "./SignEditor.vue?vue&type=template&id=12dd077b"
import script from "./SignEditor.vue?vue&type=script&lang=js"
export * from "./SignEditor.vue?vue&type=script&lang=js"
import style0 from "./SignEditor.vue?vue&type=style&index=0&id=12dd077b&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports